import React from 'react'

import AbsolutePageTemplate from '../../../../components/templates/AbsolutePageTemplate'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import ServiceOrderLoader from '../_load/ServiceOrderLoader'
import AssetsFieldValuesLoader from '../_load/AssetsFieldValuesLoader'
import ExecutorCertificadoLoader from '../_load/ExecutorCertificadoLoader'

const BradescoPgrPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrderLoader id={id}>
        <AssetsFieldValuesLoader>
          {/* Precisa estar DENTRO do ServiceOrderLoader: resolve o executor
              (`serviceOrder.user`) para então buscar o Campo Adicional "Certificado de
              Calibração" na conta dele — ver Seção 21, `21.CertificadoCalibracaoSection.js`. */}
          <ExecutorCertificadoLoader>
            <PageHeader templateId={parseInt(templateId)} />
            <PageContent />
          </ExecutorCertificadoLoader>
        </AssetsFieldValuesLoader>
      </ServiceOrderLoader>
    </AbsolutePageTemplate>
  )
}

export default BradescoPgrPdfPage
